module.exports = __webpack_public_path__ + "static/img/Tech_06.eb090fc3.png";